import { useLocation } from "react-router-dom";
import VisitGuideManage from "./visit-guide-manage";
import Device from "./device";
import ScheduledVisit from "./scheduled-visit";
import ProtectedRoute from "ProtectedRoute";
import { notUserRoles, UserRole } from "utils/role";
import MyVisitManage from "./my-visit-manage";
import PolicyManage from "./policy-manage";
import RedirectRoute from "RedirectRoute";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";
import UI from "@mile-meeting/mile-ui";
import AlertModal from "uis/modal/alert-modal";
import Root from "pages/root";
import SlackConnectWarning from "uis/top-bar/slack-connect-warning";

const VisitorsNavigation = () => {
  const location = useLocation().pathname;
  const paths = decodeURIComponent(location).split("/");
  const workspaceInfo = useRecoilValue(workspace);

  const getPage = () => {
    switch (paths[2]) {
      case "나의 방문 관리":
        return (
          <ProtectedRoute
            element={<MyVisitManage />}
            page={paths[2]}
            accessRoles={workspaceInfo?.mileVisitorsUsage ? undefined : notUserRoles}
          />
        );
      case "서비스 커스터마이징":
        switch (paths[3]) {
          case "방문 안내 메시지 관리":
            return (
              <ProtectedRoute
                element={<VisitGuideManage />}
                page={paths[3]}
                accessRoles={
                  workspaceInfo?.mileVisitorsUsage
                    ? [UserRole.Owner, UserRole.SuperAdmin, UserRole.PolicyAdmin]
                    : notUserRoles
                }
              />
            );
          case "사전 방문 관리":
            return (
              <ProtectedRoute
                element={<ScheduledVisit />}
                page={paths[3]}
                accessRoles={
                  workspaceInfo?.mileVisitorsUsage
                    ? [UserRole.Owner, UserRole.SuperAdmin, UserRole.PolicyAdmin]
                    : notUserRoles
                }
              />
            );
          case "체크인":
            return (
              <ProtectedRoute
                element={<PolicyManage />}
                page={paths[3]}
                accessRoles={
                  workspaceInfo?.mileVisitorsUsage
                    ? [UserRole.Owner, UserRole.SuperAdmin, UserRole.PolicyAdmin]
                    : notUserRoles
                }
              />
            );
          default:
            return (
              <RedirectRoute
                page={`/visitors/${encodeURIComponent("서비스 커스터마이징")}/${encodeURIComponent("사전 방문 관리")}`}
              />
            );
        }
      case "기기 관리":
        return (
          <ProtectedRoute
            element={<Device />}
            page={paths[2]}
            accessRoles={
              workspaceInfo?.mileVisitorsUsage
                ? [UserRole.Owner, UserRole.SuperAdmin, UserRole.PolicyAdmin]
                : notUserRoles
            }
          />
        );
      default:
        return <RedirectRoute page={`/visitors/${encodeURIComponent("나의 방문 관리")}`} />;
    }
  };

  return (
    <>
      <Root>{getPage()}</Root>
    </>
  );
};

export default VisitorsNavigation;
